'use client';
import Block from '@components/Layout/Block';
import { useTranslations } from 'next-intl';
import { FC, useState } from 'react';
import DefaultEmbeddedForm from './DefaultEmbeddedForm';
import {
  ContactDescriptionContainer,
  Container,
  DesktopHeader,
  GridTopContainer,
  Header,
  Text,
} from './styles';

interface ContactFormProps {
  header: string;
  bodyText: string;
  ctaText: string;
  disclaimer?: string;
  userData?: Record<string, string>;
  extraGutterWidth?: boolean;
  chimeId?: string;
  chimeType?: string;
  ownershipId?: string;
  ownershipScope?: string;
  welcomeEmail?: boolean;
  zipCode?: string;
  className?: string;
}

const ContactForm: FC<ContactFormProps> = ({
  header,
  bodyText,
  ctaText,
  disclaimer,
  userData,
  extraGutterWidth,
  chimeId = '0',
  chimeType = 'EV Global',
  ownershipId,
  ownershipScope,
  welcomeEmail,
  zipCode,
  className,
}) => {
  const t = useTranslations();
  const [formSuccess, setFormSuccess] = useState<boolean | null>(null);

  return (
    <Block backgroundInner={'secondaryBg'} full className={className}>
      <Container $isSent={formSuccess} data-testid="contact-form-container">
        <ContactDescriptionContainer>
          <DesktopHeader>
            {header && (
              <Header
                data-testid="contact-form-header"
                style={{ marginBottom: '12px', marginTop: '40px' }}
              >
                {header.toUpperCase()}
              </Header>
            )}
            {bodyText && typeof bodyText === 'string' && (
              <Text data-testid="contact-form-description">{bodyText as string}</Text>
            )}
          </DesktopHeader>
        </ContactDescriptionContainer>
        <GridTopContainer>
          <DefaultEmbeddedForm
            ctaText={ctaText}
            disclaimer={disclaimer ?? t('ContactForm.disclaimer')}
            userData={userData}
            extraGutterWidth={extraGutterWidth}
            setFormSuccess={setFormSuccess}
            chimeId={chimeId}
            chimeType={chimeType}
            ownershipId={ownershipId}
            ownershipScope={ownershipScope}
            welcomeEmail={welcomeEmail}
            zipCode={zipCode}
            isStackedImageForm={false}
          />
        </GridTopContainer>
      </Container>
    </Block>
  );
};

export default ContactForm;
